import { computed, observable, makeAutoObservable } from 'mobx';
import { reduxImmutableHash } from './utils/reduxImmutableHash';
import { ReduxRawState } from './utils/ReduxRawState';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';

const LegsIO = t.interface({
    legs: t.record(
        t.string,
        t.record(
            t.string,
            t.interface({
                selectionId: t.union([t.number, t.undefined, t.null]),
            })
        )
    ),
});

const isLegs = createGuard(LegsIO);

// const isNumner = createGuard(t.number);

const parseNumber = (value: string): number | null => {
    const valueNumber = parseInt(value, 10);
    if (!isNaN(valueNumber)) {
        return valueNumber;
    }

    return null;
};

class CurrentState {
    @observable.ref public current: Map<number, Set<number>>;

    public constructor() {
        this.current = new Map();
        makeAutoObservable(this);
    }
}

class SelectionState {
    public constructor(
        public readonly currentState: CurrentState,
        public readonly userId: number,
        public readonly selectionId: number
    ) {
        makeAutoObservable(this);
    }

    @computed public get isSelect(): boolean {
        const userData = this.currentState.current.get(this.userId);

        if (userData === undefined) {
            return false;
        }

        return userData.has(this.selectionId);
    }
}

class UserState {
    private readonly data: MobxMapAutoNew<number, SelectionState>;

    public constructor(currentState: CurrentState, userId: number) {
        this.data = new MobxMapAutoNew((selectionId: number) => new SelectionState(currentState, userId, selectionId));
    }

    public isSelectedSelection(selectionId: number): boolean {
        return this.data.get(selectionId).isSelect;
    }
}

export class ReduxBetslipSelectedLeg {
    private readonly current: CurrentState = new CurrentState();
    private readonly data: MobxMapAutoNew<number, UserState>;

    public constructor(reduxStore: ReduxRawState) {
        this.data = new MobxMapAutoNew((userId) => new UserState(this.current, userId));

        reduxImmutableHash(
            reduxStore,
            (state: Record<string, unknown>): unknown => state.betslip,
            (data: unknown): void => {
                if (data === undefined) {
                    return;
                }

                if (isLegs(data)) {
                    const result = new Map();
                    for (const [userIdString, userData] of Object.entries(data.legs)) {
                        const userId = parseNumber(userIdString);

                        if (userId === null) {
                            console.error('Legs, error userId', userId, data);
                        } else {
                            const selections = new Set();

                            for (const selectionRecord of Object.values(userData)) {
                                const selectionId = selectionRecord.selectionId ?? null;

                                if (selectionId !== null) {
                                    selections.add(selectionId);
                                }
                            }

                            result.set(userId, selections);
                        }
                    }

                    this.current.current = result;
                } else {
                    console.error('Legs error', data);
                }
            }
        );
    }

    public isSelected = (userId: number, selectionId: number): boolean => {
        return this.data.get(userId).isSelectedSelection(selectionId);
    };
}
